import { getCsrfCode } from 'portal-common-account/src/utils/csrfCode';
import { addParamsToUrl } from 'portal-common-account/src/utils/url';
import { getUinAndSkey } from 'portal-common-account/src/utils/user';

import { baseCall, baseCallWithUser } from './index';

export function getSubAccountLoginInfo() {
  return baseCall('/account/login/ajax/subAccount?action=subAccount', {
    method: 'post',
  });
}

export function quitLogin() {
  return baseCall('/account/login/ajax?action=quit', {
    method: 'post',
  });
}

export function getForwardData(data) {
  return baseCall('/account/login/ajax/forward?action=forward', {
    method: 'post',
    body: data,
  });
}

export function getVerifyData() {
  return baseCall('/account/login/ajax/verify?action=verify', {
    method: 'post',
  });
}

export function sendEmailLogin(data) {
  return baseCall('/account/login/ajax?action=login', {
    method: 'post',
    body: data,
  });
}

export function verifyAccount(data) {
  return baseCallWithUser('/account/login/ajax?action=verify', {
    method: 'post',
    body: data,
  });
}

export function sendPhoneVerifyCode(data) {
  return baseCallWithUser('/account/login/ajax?action=sendPhoneVerifyCode', {
    method: 'post',
    body: data,
  });
}

export function sendEmailVerifyCode(data) {
  return baseCallWithUser('/account/login/ajax?action=sendEmailVerifyCode', {
    method: 'post',
    body: data,
  });
}

export function subAccountLogin(data) {
  return baseCallWithUser('/account/login/ajax?action=subAccountLogin', {
    method: 'post',
    body: data,
  });
}

export function checkLogin(data) {
  const { uin, skey } = getUinAndSkey();
  return baseCall(
    addParamsToUrl('/account/login/ajax/info?action=checkLogin', {
      ...data,
      csrfCode: getCsrfCode(skey),
      uin,
    }),
    {
      method: 'get',
    },
  );
}

export function checkLoginStatus(data) {
  return baseCallWithUser('/account/login/ajax?action=checkLoginStatus', {
    method: 'post',
    body: data,
  });
}

export function authUserSAMLRequest(data) {
  return baseCallWithUser('/account/login/ajax?action=authUserSAMLRequest', {
    method: 'post',
    body: data,
  });
}

export function userSSOAuthRequest(data) {
  return baseCallWithUser('/account/login/ajax?action=userSSOAuthRequest', {
    method: 'post',
    body: data,
  });
}

export function applyLoginIpUnlock(data) {
  return baseCallWithUser('/account/login/ajax?action=applyLoginIpUnlock', {
    method: 'post',
    body: data,
  });
}

export function getLoginIpUnlockTokenStatus(data) {
  return baseCallWithUser('/account/login/ajax?action=getLoginIpUnlockTokenStatus', {
    method: 'post',
    body: data,
  });
}

export function clearLoginLimitToken(data) {
  return baseCallWithUser('/account/login/ajax?action=clearLoginLimitToken', {
    method: 'post',
    body: data,
  });
}

export function getLoginState(data) {
  return baseCallWithUser('/account/login/ajax?action=getLoginState', {
    method: 'post',
    body: data,
  });
}

export function bindSubAccountMFA(data) {
  return baseCall('/account/login/ajax/mfa?action=bindSubAccountMFA', {
    method: 'post',
    body: data,
  });
}

export function getSoftTempSN() {
  return baseCall('/account/login/ajax/mfa?action=getSoftTempSN', {
    method: 'get',
  });
}

export function seedToken() {
  return baseCallWithUser('/account/login/ajax?action=seedToken', {
    method: 'post',
  });
}

export function samlLogin(data, query) {
  return baseCall(addParamsToUrl('/account/login/saml/mfa?action=getSoftTempSN', query), {
    method: 'post',
    body: data,
  });
}

// 验证谷歌Id Token
export function verifyGoogleIdToken(data) {
  return baseCall('/account/oauth/ajax/google?action=verifyGoogleIdToken', {
    method: 'post',
    body: data,
  });
}
